import confetti from 'canvas-confetti';

// Brand colors from https://brand.customer.io/docs/color
export const BRAND_VERDANT = '#E4FFCE';
export const BRAND_EVERGREEN = '#0B353B';

export function fireConfetti(element: HTMLElement | null, options: confetti.Options = {}) {
  if (element == null) {
    return;
  }
  const bounds = element.getBoundingClientRect();
  confetti({
    startVelocity: 30,
    disableForReducedMotion: true,
    colors: [BRAND_VERDANT, BRAND_EVERGREEN],
    scalar: 0.6,
    ...options,
    origin: {
      x: (bounds.left + bounds.width / 2) / window.innerWidth,
      y: (bounds.top + bounds.height / 2) / window.innerHeight,
    },
  });
}

/** How many pieces a full burst throws. */
const BURST_PIECE_COUNT = 200;

/** The bursts a celebration throws at once: narrow and fast through to wide and slow. */
const BURSTS: readonly { share: number; options: confetti.Options }[] = [
  { share: 0.25, options: { spread: 26, startVelocity: 55 } },
  { share: 0.2, options: { spread: 60 } },
  { share: 0.35, options: { spread: 100, decay: 0.91, scalar: 0.8 } },
  { share: 0.1, options: { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 } },
  { share: 0.1, options: { spread: 120, startVelocity: 45 } },
];

let logoShape: confetti.Shape | undefined;

/**
 * The logo's diamond, built on the first celebration and then reused.
 * `shapeFromPath` draws the path on a canvas, which is not worth paying for on
 * a page load that never celebrates.
 */
function getLogoShape(): confetti.Shape {
  logoShape ??= confetti.shapeFromPath({ path: 'M4.5 0L9 4.5L4.5 9H0V4.5L4.5 0Z' });
  return logoShape;
}

/** A celebration from the middle of the screen, in the brand colours and the logo's shape. */
export function fireConfettiBurst(): void {
  for (const burst of BURSTS) {
    confetti({
      disableForReducedMotion: true,
      colors: [BRAND_VERDANT, BRAND_EVERGREEN],
      shapes: [getLogoShape()],
      ...burst.options,
      particleCount: Math.floor(BURST_PIECE_COUNT * burst.share),
    });
  }
}
